/**
 * Pollo Runway Gen 4 Turbo
 * - 文本转视频：无需 image，仅校验 prompt/length/aspectRatio/seed
 * - 图片转视频：image 必填，且只能是图片 URL（HTTPS），不支持 base64
 * input: image(URL 可选), prompt(必填), length(5|10), aspectRatio, seed
 */
import { isUrl } from './utils'

var ASPECT_RATIOS = ['16:9', '9:16', '1:1', '4:3', '3:4', '21:9']

function normalizeLength(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 5
  return num === 10 ? 10 : 5
}

function normalizeAspectRatio(v) {
  if (!v || typeof v !== 'string') return '16:9'
  var s = String(v).replace(/：/g, ':').trim()
  return ASPECT_RATIOS.indexOf(s) !== -1 ? s : '16:9'
}

export function buildBody(params) {
  var imageUrl = params.referenceImage && typeof params.referenceImage === 'string' ? params.referenceImage.trim() : ''
  var prompt = (params.prompt || '').trim().slice(0, 1000)
  if (!prompt) throw new Error('prompt 必填')
  var input = {
    prompt: prompt,
    length: normalizeLength(params.videoDuration || params.length || 5),
    aspectRatio: normalizeAspectRatio(params.aspectRatio)
  }
  // 仅在图片转视频模式下强制要求 image URL
  if (params.videoMode === 'image') {
    if (!isUrl(imageUrl)) {
      throw new Error('Runway Gen 4 Turbo 图片转视频仅支持图片 URL（HTTPS），请传 referenceImage 为有效 URL')
    }
    input.image = imageUrl
  }
  // 前端默认 seed 为 -1（随机种子），但后端希望显式接收到该值，由服务端决定随机策略
  // 因此只在 seed 为空字符串或 null 时不传，其余（包括 -1）都按数字透传
  var seed = params.seed != null && params.seed !== '' ? parseInt(params.seed, 10) : null
  if (seed != null && !isNaN(seed) && seed <= 2147483647) input.seed = seed
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
